export default {
  'addOA.title': 'Join OA',
  'addOA.button.text': 'Add Friend to Receive Voucher!',
  'addOA.content.text': 'After adding the official account as a friend, you will receive and be able to use this voucher, as well as receive more discounts and benefit notifications.',
} as Record<string, string>;
